import React from "react";
import SuggestionsPickerSelectedProps from "./SuggestionsPickerSelectedProps";
import CircleXSvg from "../../../svg/CircleXSvg";
import { LoadingState } from "../../../http";
import styles from "../../auto-suggest.module.css";

const PeoplePickerSelected: React.FC<SuggestionsPickerSelectedProps> = ({
  selectedItem,
  clearSelected,
  loadingState = LoadingState.RESOLVED,
  disabled,
  isSquare,
}): JSX.Element => {
  const holderStyle = disabled
    ? `${styles["suggestions-picker-replacement"]} ${styles["suggestions-picker-replacement-disabled"]}`
    : styles["suggestions-picker-replacement"];

  const selectedItemText = selectedItem ? selectedItem.title : "Loading...";
  const selectedElement = (
    <div className={isSquare ? styles["square"] : styles["round"]}>
      <div className={holderStyle}>
        <div className={styles["suggestions-picker-replacement-text"]}>
          {selectedItemText}
        </div>
        {selectedItem && !disabled && (
          <div
            className={styles["suggestions-picker-replacement-circle-holder"]}
            onClick={clearSelected}
            data-testid="people-picker-cancel-button"
          >
            <CircleXSvg />
          </div>
        )}
      </div>
    </div>
  );

  const isLoading = loadingState === LoadingState.LOADING;

  return <React.Fragment>{!isLoading && selectedElement}</React.Fragment>;
};

export default PeoplePickerSelected;
